export class ExpenseDetail {
    public ID: number;
    public HashCode: string;
    public SchoolID: number;
    public Expense_HashCode: string;
    public ExpenseTypeID:number;
    public ExpenseAmount:number;
    public TaxByTrust:number;
    public TaxByCollege:number;
    public StudentInsurance:number;
    public TeachingInsurance:number;
    public NonTeachingInsurance:number;
    public BuildingInsurance:number;
    public NameOfTax: string;
    public YearID:number;
}